import React from "react";
import RoadmapCard from "./RoadmapCard";
import roadmap1 from "../assets/images/11.png";
import roadmap2 from "../assets/images/12.png";
import roadmap3 from "../assets/images/13.png";
import roadmap4 from "../assets/images/14.png";
import roadmap5 from "../assets/images/15.png";
import roadmap6 from "../assets/images/roadmap6.jpg";

const Roadmap = (props) => {
  const data = [
    {
      subHeading: "Phase 1",
      imageSrc: roadmap1,
      heading: "LAUNCH",
      para: "Discord Launch",
      icon: "fas fa-microscope",
      order1: "pe-5",
      order2: "ps-5",
      subHeading2: "Phase 2",
      heading2: "Giveaways & Merch",
      para2:
        "Free WL and NFTS to OG members",
      icon2: "fas fa-glass-cheers",
    },
    {
      subHeading: "Phase 3",
      imageSrc: roadmap2,
      heading: "MINTING DAY",
      para: "Sol Survivors Mint",
      icon: "fas fa-store",
      order1: "order-md-2 ps-5",
      order2: "order-md-1 pe-5 text-end",
      subHeading2: "Phase 4",
      heading2: "UPCOMING RAFFLES",
      para2:
        "Daily WL giveaways and raffles from upcoming SOL and ETH projects",
      icon2: "fas fa-users",
    },
    {
      subHeading: "Phase 5",
      imageSrc: roadmap3,
      heading: "COMMUNITY DAO",
      para: "DAO wallet will be used to raffle off big NFTS and SOL",
      icon: "fas fa-broom",
      order1: "pe-5",
      order2: "ps-5",
     
    },
    {
      subHeading: "Phase 6",
      heading: "NEW ROADMAP",
      para: "Roadmap 2.0…",
      icon: "fas fa-ring",
      order1: "order-md-2 ps-5",
      order2: "order-md-1 pe-5 text-end",
      subHeading2: "Phase 7",
      imageSrc: roadmap4,
      heading2: "2ND PHASE OF SOLSURVIVORS",
      para2:
        "3D SolSurvivors",
    },
   
  ];
  return (
    <section id="Roadmap">
      <div className="container">
        <div className="roadmapInfo text-center">
          <h1 className="sectionHeading">
            <span>Roadmap</span>
          </h1>
          <h6>Gain additional benefits through roadmap activations.</h6>
        </div>
        <div className="roadmapSection my-5">
          {data.map((item) => (
            <div style={{ position: "relative", padding: "1.5em 0" }}>
              <RoadmapCard data={item} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default Roadmap;
